module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/kent-state-university-184d5fd28af23bd2278525b7e4cad785.jpg";